import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getViewerHideColumnsAPI = createApi("GetViewerHideColumns","GET");

const GetViewerHideColumns = createSlice({
  name: 'GetViewerHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewerHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewerHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewerHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetViewerHideColumns.reducer;